/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { SystemReportItem } from 'items/system-reports.item.factory';

export const SYSTEM_REPORTS_COLLECTION_TOKEN = 'SystemReportsCollection';

/**
 * @description SystemReports Collection
 * @author Deepak Chaudhary
 */
export class SystemReportsCollection extends Collection {
    public static ngDependencies = [
        SystemReportItem,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            permissionName: AviPermissionResource.PERMISSION_CONTROLLER,
            objectName: 'systemreport',
            windowElement: 'lazy-load',
            sortBy: 'name',
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getNgDependency(SystemReportItem);
    }
}

export type TSystemReportsCollection = typeof SystemReportsCollection;
